export default __webpack_public_path__ + "static/media/information--living-street--g3.25c4364f.png";